import { getDefaultTemplate, getBaselineTemplate } from '../helpers';

export default function (data) {
  const baselineTemplate = data.isBaseline ? getBaselineTemplate(data.baselineValue) : '';

  return `${getDefaultTemplate(data.cellValue)}${baselineTemplate}`;
}
